import type { OfficeActionHeader } from '../types/office-action-header';

/**
 * 获取审查意见通知书元数据的参数
 */
export interface GetHeaderParams {
    /** 任务标识符 */
    taskId: string;
}

/**
 * 审查意见通知书元数据服务接口
 */
export interface OfficeActionHeaderService {
    /**
     * 根据任务ID获取审查意见通知书元数据
     * @param params - 参数对象
     * @returns 审查意见通知书元数据
     */
    getHeader(params: GetHeaderParams): Promise<OfficeActionHeader>;
}

export const OfficeActionHeaderService = Symbol('OfficeActionHeaderService');
